import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

import AnalyticsService from 'cio/services/analytics';

export default class ActionsTwilioController extends Controller {
  @service analytics!: AnalyticsService;

  @tracked showModal = false;
  @tracked deleteFn: (() => void) | null = null;
  @tracked twilioChannels = ['twilio'];

  @action
  onLoad() {
    this.analytics.track('twilio', 'settings_viewed', { enabled: true });
  }

  @action
  onErrorLoading() {
    this.analytics.track('twilio', 'settings_viewed', { enabled: false });
  }

  @action
  onDisable(deleteFn: () => void) {
    this.startDelete(deleteFn);
  }

  @action
  startDelete(deleteFn: () => void) {
    this.deleteFn = deleteFn;
    this.showModalAction();
  }

  @action
  showModalAction() {
    this.showModal = true;
  }

  @action
  closeModal() {
    this.deleteFn = null;
    this.showModal = false;
  }

  deleteTask = task(
    {
      drop: true,
    },
    async () => {
      try {
        this.deleteFn?.();
      } catch (e) {
        // Ignore promise failure
      } finally {
        this.closeModal();
      }
    },
  );
}
